import React from 'react';

import { useTranslation } from 'react-i18next';
import { Box, HStack, VStack, Heading, Text } from '@gluestack-ui/themed';

import UserMenu from '../../../common/navigation/components/UserMenu';
import { User } from 'lucide-react-native';

const Greeting = ({ user, showMenu, handleLogout, accentColor }) => {
  const { t } = useTranslation();

  const { firstname } = user;
  return (
    <HStack $base-mt="$8" $lg-mt={0} mb={32} justifyContent="space-between">
      <VStack>
        <HStack space="sm" alignItems="center">
          <Box w={4} h={24} bg={accentColor || '$brandBase'} borderRadius="$full" />
          <Heading testID="greeting-title">{t('student.course.greeting.screentitle')}</Heading>
        </HStack>
        <Text testID="greeting-welcome" ml="$3">
          {t('student.course.greeting.welcome', { name: firstname })}
        </Text>
      </VStack>
      {showMenu && <UserMenu testID="user-menu" user={user} logout={handleLogout} placement="bottom right" />}
    </HStack>
  );
};

export default Greeting;
